const BRIDGE_BASE_URL = '/apps/apibridge/integration/path/';
const HC_API = {
    GET_PICKUP_AVAILABILITY: "/apps/hollyconnect/bff/get-warehouse-inventory",
    GET_GUEST_ORDER: "/apps/hollyconnect/bff/get-order",
    GET_INSTALLMENT: "/apps/holly-payments/payment/installment-plans",
    GET_STORES: "/apps/hollyconnect/bff/get-store-list",
    CHECK_CUSTOMER_STATE: "/apps/holly-account/Shopify/check-customer-status",
    CHECK_CUSTOMER_STATE_BY_PHONE: "/apps/holly-account/Shopify/check-customer-status-phone",
    CHECK_PHONE: "/apps/holly-account/Customer/phone-check",
    LOGIN_WITH_PHONE: "/apps/holly-account/Customer/customer-phone-login",
    GENERATE_OTP: "/apps/holly-account/otp/generate",
    VALIDATE_OTP: "/apps/holly-account/otp/validate",
    GET_STORE: "/apps/hollyconnect/bff/get-store",
    GET_COUPON_DATA: "/apps/holly-account/Customer/customer-discounts",
    SEND_CALLME_FORM: "/apps/hollyconnect/Form/submit",
    SEND_MAIL_ACTIVATION: "/apps/holly-account/Shopify/send-mail-activation",
    UPDATE_CUSTOMER: '/apps/holly-account/customer/upsert',
    SEND_RETURN_ITEMS: "/apps/hollyconnect/bff/refund",
    SEND_CANCEL_ITEMS: "/apps/hollyconnect/bff/cancel",
    SET_ADDRESS_METAFIELD: "/apps/holly-account/Address/upsert-address",
    MAKE_ANONYMOUS: "/apps/holly-account/Customer/make-anonymous",
    DELETE_ADDRESS_METAFIELD: "/apps/holly-account/Address"
};

const OTP_DATA = {
  DURATION_SEC: 300,
  LENGTH: 6,
  get ERROR_MESSAGE() {
      return window.otp?.locales?.ERROR_MESSAGE;
  },
  get EXPIRED_MESSAGE() {
      return window.otp?.locales?.EXPIRED_MESSAGE;
  },
  get WRONG_CODE_ERROR_MESSAGE() {
      return window.otp?.locales?.WRONG_CODE_ERROR_MESSAGE;
  },
  get ALREADY_USED_EMAIL_MESSAGE() {
      return window.otp?.locales?.ALREADY_USED_EMAIL_MESSAGE;
  },
  get RATE_LIMIT_ERROR_MESSAGE() {
      return window.otp?.locales?.RATE_LIMIT_ERROR_MESSAGE;
  },
  get PHONE_ALREADY_USED_MESSAGE() {
      return window.otp?.locales?.PHONE_ALREADY_USED_MESSAGE;
  },
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
const CUSTOMER_ENABLED_STATE = "ENABLED";
const OTP_WRONG_CODE_MESSAGES = ['OTP has already been used', 'OTP not found'];
const MAIN_COUNTRY_ISO_CODE = 'tr';

function getBodyFromApiBridgeResponse(response) {
    try {
        if(response && response.data){
            if(response.data.status === 200 && response.data.body) {
                const responseBody = response.data.body;
                const responseBodyJson = JSON.parse(responseBody);
                return responseBodyJson;
            } else if(response.data.status === 404) {
                return response.data;
            }
        }
        return null;
    } catch (error) {
        return null;
    }
}